<template>
  <div>
    <div>
      <HeaderOfPage :bgSrc="'banner-blog.jpg'" :theDiscription="'الاتيكيت'" :titleOfPage="'الاتيكيت ونصائح قبل السفر'"/>
    </div>
    <section class="pages-container blogpage">
      <b-container>
        <b-row>
          <b-col sm="3">
            <AsideBlog/>
          </b-col>
          <b-col sm="9">
            <b-row>
              <b-col sm="12" v-for="b in 4" :key="b">
                <SingleBlog/>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>
<script type="text/javascript">
  import HeaderOfPage from '../global/HeaderOfPage'
  import AsideBlog    from './AsideBlog'
  import SingleBlog   from '../global/SingleBlog'
  export default {
    name: 'Blog',
    components: {
      HeaderOfPage,
      AsideBlog,
      SingleBlog
    }
  }
</script>
